<section class="bn-open-actions" aria-label="Open actions">
  <div class="bn-open-actions__filters" aria-label="Filter open actions">
    <p-select
      [options]="ownerOptions()"
      optionLabel="label"
      optionValue="value"
      [ngModel]="ownerFilter()"
      (ngModelChange)="ownerFilter.set($event)"
      ariaLabel="Filter actions by assigned FA"
      appendTo="body"
    />
    <p-select
      [options]="caseOptions()"
      optionLabel="label"
      optionValue="value"
      [ngModel]="caseFilter()"
      (ngModelChange)="caseFilter.set($event)"
      ariaLabel="Filter actions by case"
      appendTo="body"
    />
    @if (hasFilters()) {
      <span class="bn-open-actions__count" role="status"
        >{{ filteredActions().length }} of {{ store().count() }} actions</span
      >
      <button
        type="button"
        class="bn-open-actions__reset"
        (click)="resetFilters()"
      >
        Reset filters
      </button>
    }
  </div>

  @if (store().loading()) {
    <div
      class="bn-open-actions__loading flex flex-col gap-3"
      role="status"
      aria-label="Loading open actions"
    >
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
    </div>
  } @else if (store().error(); as error) {
    <div class="bn-open-actions__message" role="alert">
      <p class="m-0">{{ error }}</p>
      <button type="button" (click)="store().retry()">Retry</button>
    </div>
  } @else if (store().actions().length === 0) {
    <div class="bn-open-actions__message" role="status">
      <p class="m-0">No open actions.</p>
    </div>
  } @else if (filteredActions().length === 0) {
    <div class="bn-open-actions__message" role="status">
      No actions match these filters.
    </div>
  } @else {
    <div
      class="bn-open-actions__cards"
      role="region"
      aria-label="Open actions for this client"
    >
      @for (action of filteredActions(); track action.id) {
        <bn-action-card
          entryPoint="care_plan_client"
          [action]="action"
          [store]="store()"
          [caseDomainLabel]="caseDomainLabel(action)"
          [showGoToCase]="hasLinkedCase(action)"
          [readonly]="readonly()"
          (goToCase)="goToCase.emit($event)"
        />
      }
    </div>
  }
</section>
